import { mapState, mapGetters, mapActions } from 'vuex'

export const appAuthComputed = {
  ...mapState('appAuth', {
    appSession: (state) => state.appSession,
  }),
  ...mapGetters('appAuth', ['appLoggedIn','updateCompanyInfo']),
}

export const appAuthMethods = mapActions(
  'appAuth', ['appLogIn', 'companyInfoExists'])


export const authComputed = {
  ...mapState('auth', {
    currentSession: (state) => state.currentSession,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions(
  'auth', ['logIn', 'logOut', 'register',
  'resetPassword', 'setUserActiveSection'])


export const languageComputed = {
  ...mapState('language', {
    language: (state) => state.language,
  })
}
  
export const languageMethods = mapActions(
  'language', ['setLanguage'])

export const usersComputed = {
  ...mapState('users', {
    cached: (state) => state.cached,
  }),
}

export const usersMethods = mapActions(
  'users', [
    'fetchUsers', 'createUpdateUsers',
    'deleteUsers', 'changePassword', 
    'updatePhotos', 'fetchUsersDetail',
    'fetchUsersForOptions', 'checkIfUserExists',
    'registerUsers']
)

export const permsComputed = {
  ...mapState('perms', {
    cached: (state) => state.cached,
  }),
}

export const permsMethods = mapActions(
  'perms', ['fetchPerms', 'createUpdatePerms',
  'deletePerms', 'fetchPermsDetail'])


export const groupsComputed = {
  ...mapState('groups', {
    cached: (state) => state.cached,
  }),
}

export const groupsMethods = mapActions(
  'groups', ['fetchGroups', 'createUpdateGroups', 
  'deleteGroups', 'fetchGroupsDetail'])

export const appSectionsComputed = {
  ...mapState('appSections', {
    cached: (state) => state.cached,
  }),
}

export const appSectionsMethods = mapActions(
  'appSections', ['fetchAppSections', 'createUpdateAppSections',
  'deleteAppSections', 'fetchAppSectionsDetail'])



export const companyInfoComputed = {
  ...mapState('companyInfo', {
    cached: (state) => state.cached,
  }),
}

export const companyInfoMethods = mapActions(
  'companyInfo', ['fetchCompanyInfo', 'createUpdateCompanyInfo', 'setFileCompanyInfo'])

// Periodic tasks helpers
export const periodicTasksMethods = mapActions(
  'periodicTasks', ['fetchPeriodicTasks', 'createUpdatePeriodicTasks', 
  'deletePeriodicTasks', 'fetchPeriodicTasksDetail', 'fetchPeriodicTasksOptions',
  'getLiveResultsPeriodicTasks', 'executeManuallyPeriodicTasks'])

export const periodicTasksResultsMethods = mapActions(
    'periodicTasksResults', ['fetchPeriodicTasksResults', 'createUpdatePeriodicTasksResults', 
    'deletePeriodicTasksResults', 'fetchPeriodicTasksResultsDetail'])

export const periodicTasksSolarScheduleMethods = mapActions(
  'periodicTasksSolarSchedule', ['fetchPeriodicTasksSolarSchedule', 'createUpdatePeriodicTasksSolarSchedule', 
  'deletePeriodicTasksSolarSchedule', 'fetchPeriodicTasksSolarScheduleDetail'])

export const periodicTasksIntervalScheduleMethods = mapActions(
  'periodicTasksIntervalSchedule', ['fetchPeriodicTasksIntervalSchedule', 'createUpdatePeriodicTasksIntervalSchedule', 
  'deletePeriodicTasksIntervalSchedule', 'fetchPeriodicTasksIntervalScheduleDetail'])

export const periodicTasksClockedScheduleMethods = mapActions(
  'periodicTasksClockedSchedule', ['fetchPeriodicTasksClockedSchedule', 'createUpdatePeriodicTasksClockedSchedule', 
  'deletePeriodicTasksClockedSchedule', 'fetchPeriodicTasksClockedScheduleDetail'])

export const periodicTasksCrontabScheduleMethods = mapActions(
  'periodicTasksCrontabSchedule', ['fetchPeriodicTasksCrontabSchedule', 'createUpdatePeriodicTasksCrontabSchedule', 
  'deletePeriodicTasksCrontabSchedule', 'fetchPeriodicTasksCrontabScheduleDetail'])

// Gyc warehouse helpers
export const warehouseMethods = mapActions(
  'warehouse', ['fetchWarehouses', 'createUpdateWarehouse',  'fetchWarehouseDetail',
  'fetchWarehouseOptions',
  'deleteWarehouse',
])


// Gyc Options helpers
export const optionsMethods = mapActions(
  'options', [
  //   'fetchEcommerces', 
  // 'createUpdateWarehouse', 
  // 'deleteEcommerce', 'fetchEcommerceDetail', 
  'fetchEcommerceOptions',
  'fetchCustomerTypeOptions',
  'fetchDocumentTypeOptions',
  'fetchVendorOptions',
  'fetchPaymentConditionOptions',
  'fetchBussinessUnitOptions',


  ])

// Gyc Ecommerce helpers
export const adminsMethods = mapActions(
  'admins', [
    'fetchAdmins', 
  'createUpdateAdmin', 
  'deleteEcommerce', 
  'fetchAdminDetail', 
  'fetchAdminsOptions',
  'deleteAdmin'
  ])
